let currentProjectId = null
let currentGeneration = 0

export function beginProjectTransition(projectId) {
	currentGeneration += 1
	currentProjectId = projectId || null
	return currentGeneration
}

export function setCurrentProject(projectId, generation) {
	if (generation !== currentGeneration) return false
	currentProjectId = projectId || null
	return true
}

export function getProjectGeneration() {
	return currentGeneration
}

export function getProjectRequest(projectId) {
	return {
		projectId: projectId || currentProjectId,
		generation: currentGeneration,
	}
}

export function isCurrentProjectRequest(projectId, generation) {
	return generation === currentGeneration && (projectId == null || Number(projectId) === Number(currentProjectId))
}
